















































































































































































































































































































































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import InspectionFirstStep from './InspectionFirstStep.vue';
import InspectionThirdStep from './InspectionThirdStep.vue';
import InspectionSecondStep from './InspectionSecondStep.vue';
import {mapActions, mapGetters} from 'vuex';
import {API} from '@/services/api/api';
import {getImage, Utils} from '@/utils/Utils';
import moment from 'moment';
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import InspectionDetailsPDF from '@/components/template/InspectionDetailsPDF.vue';
import InspectionDetailsHTML from '@/components/template/InspectionDetailsHTML.vue';

import canvasMerge from '@/utils/CanvasMerge';
import html2pdf from 'html2pdf.js';
import {setInspectionDetailsList} from '@/store/actions';
@Component({
  components: {
    InspectionFirstStep,
    InspectionSecondStep,
    InspectionThirdStep,
    InnerImageZoom,
    InspectionDetailsPDF,
    InspectionDetailsHTML,
  },
  methods: {
    ...mapActions([
      'setInspectionData',
      'setInspectionDetailsList',
      'setDeckImage',
      'showSuccessToast',
      'showErrorToast',
    ]),
  },
  computed: {
    ...mapGetters(['getInspectionData', 'getInspectionDetailsList', 'getDeckImage']),
  },
})
export default class ViewInspection extends Vue {
  @Prop({default: false}) showOnlyEditBtn!: boolean;
  isScreenLoading = true;
  inspectionId = this.$route.params.id;
  setInspectionData: any;
  setInspectionDetailsList: any;
  getInspectionDetailsList: any;
  setDeckImage: any;
  getDeckImage: any;
  showSuccessToast: any;
  showErrorToast: any;
  inspectionData: any;
  inspectionDataCopy: any;
  deckImageURL = '';
  createdDeckImageUrl = '';
  howercontectText = '';
  shipDots = [];
  deckImgLoader = false;
  copyBtnLoader = false;
  deckImageName = '';
  ZoneMasterId: number = null;
  modalVisible = false;
  modalTitle = '';
  modalConfimationMsg = '';
  isReadOnly = true;
  printBtnLoader = false;
  inspectionCode = '';
  showPrintBtn = false;
  selectedId = null;
  canDeleteInspection = Utils.manageRoutePermissions('inspection', 4);
  canEditInspection = Utils.manageRoutePermissions('inspection', 3);
  mounted() {
    this.getInspectionDataById();
  }

  async getInspectionDataById() {
    try {
      const response = await API.fetchInspectionHistoryById(this.inspectionId);
      const response2 = await API.fetchInspectionDataById(this.inspectionId);

      if (response.data && response2.data) {
        const data2 = response2.data;
        this.inspectionDataCopy = data2;
        this.ZoneMasterId = data2.inspectionPoint.zoneMasterId;

        const data = response.data;
        this.inspectionData = data;
        const deck = response.deck;
        this.deckImageURL = await getImage(deck.imagePath);
        this.deckImageName = deck.fileName;
        this.createdDeckImageUrl = '';
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  formatDate(date) {
    return moment(date).format('YYYY-MM-DD');
  }

  async onDownLoadClick() {
    const data = await Utils.downloadImage(this.createdDeckImageUrl || this.deckImageURL, this.deckImageName);

    data.click();
  }

  onEditClick(id) {
    // this.$router.push('/edit-inspection/' + this.inspectionId);
    this.$router.push('/edit-inspection/' + id);
  }

  onDeleteClick(id) {
    this.selectedId = id;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure you want to delete this inspectio ?';
    // this.deleteStatus = true;
  }

  async onDeleteConfirm() {
    try {
      const response = await API.deleteInspectionById(this.selectedId);
      if (response.message) {
        this.showSuccessToast({msg: response.message});
        this.$router.push('/inspection-list');
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: error});
    }
  }

  onPrintClick() {
    this.printBtnLoader = true;
    const ref: any = this.$refs.pdfTemplateRef;
    setTimeout(() => {
      ref.htmlToPdf();
    }, 1000);
  }

  stopBtnLoader() {
    this.printBtnLoader = false;
  }

  renderDot() {
    let shipDots = [];
    if (this.deckImgLoader && this.deckImageURL && this.inspectionDataCopy && this.inspectionData) {
      let imageRef = this.$refs.deckImageRef as HTMLImageElement;
      let tempArray = [this.inspectionDataCopy];
      tempArray.map((inspection) => {
        //
        const points = inspection.additionalInfo;
        const inspectionPoint = inspection.inspectionPoint;

        let x,
          y = null;
        if (inspection.inspectionPoint.isMisc) {
          y = (points.centerFrom + points.centerUpto) / 2;

          let totalFrame = points.frameUpto - points.frameFrom;
          let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
          let pixelsInEachframes = pixelsCountInZone / totalFrame;
          let thisframePosition = points.frameUpto - inspection.inspectionDetail.frameNumber;
          x = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
        } else {
          y = inspectionPoint.location_Y;
          x = inspectionPoint.location_X;
        }
        shipDots.push({
          x: x,
          y: y,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(this.inspectionData[0].severity),
          inspectionID: inspection.inspectionId,
          inspectionCode: inspection.inspectionDetail.inspectionID,
        });
      });
      if (shipDots.length > 0) {
        this.mergeImage(shipDots);
      }
    }
  }

  //make a copy of zone lines and orignal image
  mergeImage(shipDots) {
    //
    canvasMerge(this.deckImageURL, shipDots, {
      crossOrigin: 'anonymous',
      drawType: 'circle',
    }).then((b64) => {
      //
      this.createdDeckImageUrl = b64;
      this.deckImgLoader = false;
      this.showPrintBtn = true;

      // this.$forceUpdate();
    });
  }

  deckImageLoad() {
    let _this = this;
    this.deckImgLoader = true;
    this.renderDot();
  }
}
